const findRowspan = (tokens, pos) => {
  const nextToken = tokens[pos - 1];

  return nextToken.type === 'inline' && nextToken.content === '^';
};

module.exports = function tableRowspan(md) {
  md.core.ruler.push('table_rowspan', function remover(state) {
    let spanStatus = {};
    let columnIndex;

    for (let i = state.tokens.length - 1; i >= 0; i--) {
      const token = state.tokens[i];

      if (token.type === 'table_open') {
        spanStatus = {};
        columnIndex = 0;
      }

      if (token.type === 'tr_close') {
        columnIndex = 1;
      }

      if (token.type !== 'td_close' && token.type !== 'th_close') {
        continue;
      }

      token.columnIndex = columnIndex;
      columnIndex++;

      if (findRowspan(state.tokens, i)) {
        if (!spanStatus[token.columnIndex] || spanStatus[token.columnIndex].start <= 0) {
          spanStatus[token.columnIndex] = {
            rowspan: 1,
            start: i,
          };
        }

        spanStatus[token.columnIndex].rowspan++;

        continue;
      }

      if (!spanStatus[token.columnIndex] || spanStatus[token.columnIndex].rowspan <= 1) {
        continue;
      }

      while (i >= 0) {
        const concatenatedToken = state.tokens[i];
        if (concatenatedToken.type === 'td_open' || concatenatedToken.type === 'th_open') {
          if (!concatenatedToken.attrs) {
            concatenatedToken.attrs = [];
          }

          concatenatedToken.attrs.push(['rowspan', spanStatus[token.columnIndex].rowspan]);

          for (let j = spanStatus[token.columnIndex].start; j > i; j--) {
            if (state.tokens[j].type !== 'td_close' && state.tokens[j].type !== 'th_close') {
              continue;
            }

            if (token.columnIndex !== state.tokens[j].columnIndex) {
              continue;
            }

            if (!findRowspan(state.tokens, j)) {
              continue;
            }

            while (state.tokens[j].type !== 'td_open' && state.tokens[j].type !== 'th_open') {
              state.tokens[j].toBeRemoved = true;
              j--;
            }

            state.tokens[j].toBeRemoved = true;
          }

          spanStatus[token.columnIndex].rowspan = 1;
          spanStatus[token.columnIndex].start = 0;
        }

        if (spanStatus[token.columnIndex].rowspan <= 1) {
          break;
        }

        i--;
      }
    }

    state.tokens = state.tokens.filter((v) => !v.toBeRemoved);
  });
};
